document.addEventListener("DOMContentLoaded", () => {
  const smoothScroll = document.querySelectorAll(".js-smooth-scroll");
  if (smoothScroll) {
    const header = document.querySelector(".js-header");
    const headerHeight = header ? header.clientHeight : "";
    const navi = document.querySelector(".js-nav");
    const naviHeight = navi ? navi.clientHeight : "";

    const hotelsTheme = document.getElementById("js-hotels-theme");
    smoothScroll.forEach((element) => {
      element.addEventListener("click", (event) => {
        const href = element.getAttribute("href");
        const target = document.getElementById(href.replace("#", ""));
        // NOTE: 目次には有るがページ内に飛び先が存在しない場合にエラーになるため回避
        if (target) {
          const rect = target.getBoundingClientRect().top;
          const offset = window.pageYOffset || document.documentElement.scrollTop;
          let position = rect + offset - (hotelsTheme ? 32 : naviHeight);
          if (header && position < offset) {
            position = position - headerHeight;
          }
          window.scrollTo({
            top: position,
            behavior: "smooth",
          });
          return event.preventDefault();
        }
        return false;
      });
    });
  }
});
